export function generateDomId(prefix = 'i'): string {
  return prefix + Math.random().toString(36).substr(2);
}
